import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { Button } from '@/components/ButtonComponent';
import { Screen } from '@/components/ScreenComponent';
import { ScreenNavBar } from '@/components/ScreenNavBar';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { DevDemoStackParamList } from '@/feature/devsettings/DevDemoStack';

type DemoScreenName =
    | 'NavDemoPresetPage'
    | 'NavDemoPresetSheet'
    | 'NavDemoPresetSheetDetents'
    | 'NavDemoPresetFullScreenCover';

type DemoNav = NativeStackNavigationProp<DevDemoStackParamList>;

type DemoEntry = {
    label: string;
    screen: DemoScreenName;
};

type Group = {
    title: string;
    note: string;
    entries: DemoEntry[];
};

const GROUPS: Group[] = [
    {
        title: 'page',
        note: 'Plain navigation, viewing or browsing content only.',
        entries: [{ label: 'page', screen: 'NavDemoPresetPage' }],
    },
    {
        title: 'sheet',
        note: 'Edit/action or informational, slides up.',
        entries: [
            { label: 'sheet() - full height', screen: 'NavDemoPresetSheet' },
            { label: 'sheet(detents) - fixed heights', screen: 'NavDemoPresetSheetDetents' },
        ],
    },
    {
        title: 'fullScreenCover',
        note: 'Multi-step flows, not dismissible.',
        entries: [{ label: 'fullScreenCover', screen: 'NavDemoPresetFullScreenCover' }],
    },
];

export const ScreenPresetsDemo = () => {
    const navigation = useNavigation<DemoNav>();

    return (
        <Screen>
            <ScreenNavBar title="Design System Navigation Presets" />
            <ScrollView contentContainerStyle={styles.scroll}>
                {GROUPS.map(group => (
                    <Box key={group.title} mb="s24">
                        <Text variant="labelMedium" color={ds.colorToken.text.primary} mb="s4">
                            {group.title}
                        </Text>
                        <Text variant="bodySmaller" color={ds.colorToken.text.secondary} mb="s12">
                            {group.note}
                        </Text>
                        <Box gap="s8">
                            {group.entries.map(entry => (
                                <Button
                                    key={entry.screen}
                                    label={entry.label}
                                    onPress={() => navigation.navigate(entry.screen)}
                                />
                            ))}
                        </Box>
                    </Box>
                ))}
            </ScrollView>
        </Screen>
    );
};

const styles = StyleSheet.create({
    scroll: {
        padding: 16,
        flexGrow: 1,
    },
});
